import wujiFetch from '@/utils/wujiFetch';
import { designPath } from '@config/constant';
import getXyManagePathPrefix from '@utils/getXyManagePathPrefix';

const fetchCollection = async ({ projectId, collectionId }) => await wujiFetch(`${getXyManagePathPrefix()}/datasource/collection/${collectionId}?projectid=${projectId}`);

const getAllCollection = async (projectId, filter = '') => {
  const res = await wujiFetch(`${getXyManagePathPrefix()}/datasource/basic/collection`, {
    method: 'get',
    query: {
      projectid: projectId,
      size: 'total',
      filter,
      sort: '_mtime',
      order: 'desc',
    },
  });
  return res;
};

// 获取详细版本的
const getAllDetailedCollection = async (projectId, filter = '', include = '') => {
  const res = await wujiFetch(`${getXyManagePathPrefix()}/datasource/collection`, {
    method: 'get',
    query: {
      projectid: projectId,
      size: 'total',
      filter,
      include,
      sort: '_ctime',
      order: 'desc',
    },
  });
  return res;
};

const createCollection = async (projectId, data = {}) => await wujiFetch(`${getXyManagePathPrefix()}/datasource/collection`, {
  method: 'post',
  body: JSON.stringify(data),
  query: {
    projectid: projectId,
  },
});

const updateCollection = async (projectId, data = {}, headers = {}) => {
  const res = await wujiFetch(`${getXyManagePathPrefix()}/datasource/collection/patch/${data.collectionId}`, {
    method: 'post',
    body: JSON.stringify(data),
    query: {
      projectid: projectId,
    },
    headers,
  });
  return res;
};

const getAllCollectionTag = async (projectId, filter = '') => {
  const res = await wujiFetch(`${designPath}/datasource/collection/tag`, {
    method: 'get',
    query: {
      projectid: projectId,
      size: 'total',
      filter,
    },
  });
  return res;
};

const copyCollection = async (projectId, data = {}) => await wujiFetch(`${getXyManagePathPrefix()}/datasource/collection/copy`, {
  method: 'post',
  body: JSON.stringify(data),
  query: {
    projectid: projectId,
  },
});

const deleteCollection = async (projectId, collectionId) => await wujiFetch(`${getXyManagePathPrefix()}/datasource/collection/delete/${collectionId}`, {
  method: 'post',
  query: {
    projectid: projectId,
  },
});

export default {
  fetchCollection,
  getAllCollection,
  getAllDetailedCollection,
  createCollection,
  updateCollection,
  getAllCollectionTag,
  copyCollection,
  deleteCollection,
};
